import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import Icon from '../Icons'

class Accordion extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    collapsed: PropTypes.bool.isRequired,
    additionalClass: PropTypes.string,
    rootRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  }

  static Button = ({ onClick, collapsed, additionalClass }) => (
    <span
      className={`ctp-accordion__status-icon ${
        collapsed ? 'ctp-accordion__status-icon--collapsed' : ''
      } ${additionalClass || ''}`}
      onClick={onClick}
    >
      <Icon icon={'arrow'} />
    </span>
  )

  static Head = ({ children, collapsed, handleClick, additionalClass }) => (
    <div className={`ctp-accordion__head ${additionalClass || ''}`}>
      {children}
      {handleClick && <Accordion.Button collapsed={collapsed} onClick={handleClick} />}
    </div>
  )

  static Body = ({ children, collapsed, additionalClass }) => {
    const [hasOpened, setHasOpened] = useState(!collapsed)

    useEffect(() => {
      if (!collapsed) setHasOpened(true)
    }, [collapsed])

    return (
      <div
        className={`ctp-accordion__body ${additionalClass || ''} ${
          collapsed ? 'ctp-accordion__body--collapsed' : 'ctp-accordion__body--expanded'
        }`}
      >
        <div className="ctp-accordion__body-inner">{hasOpened ? children : null}</div>
      </div>
    )
  }
  render() {
    const { children, collapsed, additionalClass, rootRef } = this.props
    return (
      <div ref={rootRef} className={`ctp-accordion ${additionalClass || ''}`}>
        {React.Children.map(children, (child) => React.cloneElement(child, { collapsed }))}
      </div>
    )
  }
}

export default Accordion
